export default __webpack_public_path__ + "img/dXtHvuow.6a79332e.svg";